import { ActionType, createAction } from 'typesafe-actions';
import { Inbox } from '@rossum/api-client/inboxes';
import { Url } from '../../../types/basic';
import { InboxParams } from '../../../types/inbox';

export const updateInboxAction = createAction(
  'UPDATE_INBOX',
  (inbox: InboxParams, _inboxUrl: Url) => ({
    inbox,
  }),
  (_inbox, inboxUrl) => ({
    inboxUrl,
  })
)<{ inbox: InboxParams }, { inboxUrl: Url }>();

export const updateInboxFulfilled = createAction(
  'UPDATE_INBOX_FULFILLED',
  (inbox: Inbox) => ({
    inbox,
  })
)<{ inbox: Inbox }>();

export type InboxActions = ActionType<
  typeof updateInboxAction | typeof updateInboxFulfilled
>;
